export default () => ({
  type: 'SEARCH_BAR_CLEAR',
});
